export const PORTAL_ORIGIN = 'https://portal.projectlevelthefield.com';

export function portalUrl(path = '') {
  if (!path) return PORTAL_ORIGIN;
  return `${PORTAL_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
